import styled from 'styled-components';
import StateChip from './StateChip';

const RowTable = ({ columns, rows }) => (
    <>
        <HeaderDetails>
            {columns.map((col) => (
                <p key={col.accessor}>{col.label}</p>
            ))}
        </HeaderDetails>
        {rows.map((row, index) => (
            <BodyDetails key={index}>
                {columns.map((col) => {
                    const raw = row[col.accessor];
                    const value = col.transform ? col.transform(raw, row) : raw;
                    return (
                        <p key={`body-${col.accessor}`}>
                            {col.accessor === 'state' ? (
                                <StateChip value={value} />
                            ) : (
                                (value ?? '-')
                            )}
                        </p>
                    );
                })}
            </BodyDetails>
        ))}
    </>
);

export default RowTable;

const HeaderDetails = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    width: calc(100% - 1rem);
    overflow-x: auto;
    padding: 0.5rem;
    background-color: #e94c4414;
    border: solid 1px #e94c4414;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;

    p {
        font-size: 0.75rem;
        font-weight: bold;
        text-transform: uppercase;
        flex-basis: calc(14.28% - 1rem);
    }
`;

const BodyDetails = styled.div`
    display: flex;
    width: calc(100% - 1rem);
    overflow-x: auto;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem;
    border-left: solid 1px #d9d9d9;
    border-right: solid 1px #d9d9d9;
    border-bottom: solid 1px #d9d9d9;
    p {
        font-size: 0.85rem;
        flex-basis: calc(14.28% - 1rem);
    }
`;
